import React, { useState, useEffect } from "react";
import { variables } from "../../config/Variables";
import { toast } from "react-toastify";
import stepIcon from "./stepIcon.png";
import pdfIcon from "./pdfIcon.png";
import ucdIcon from "./3dIcon.png";
import schemaIcon from "./schemaIcon.png";
import { useTranslation } from "react-i18next";
import IFrameWindow from "../structure/IFrameWindow";
import productService from "../../services/productService";
import { formatKatalogKodu } from "../../utils/formatters";
import { IconSearch, Icon3dCubeSphere } from "@tabler/icons-react";
import { QuickSearchInput } from "../structure/QuickSearchInput";

export const ThreeDProducts = () => {
    const { t, i18n } = useTranslation();
    const [productGroups, setProductGroups] = useState([]);
    const [groupCode, setGroupCode] = useState('*');
    const [rootGroupCode, setRootGroupCode] = useState('');
    const [sortOrder, setSortOrder] = useState("ASC");
    const [products, setProducts] = useState([]);
    const [aranacakMetin, setAranacakMetin] = useState('*');
    
    // Default olarak 3B modeli seçili gelsin
    const [model3bCheck, setModel3bCheck] = useState('1');

    const [UserId, setUserId] = useState(0);
    const [UrunId, setUrunId] = useState(0);
    const [DosyaAdi, setDosyaAdi] = useState("");
    const [productUrl, setProductUrl] = useState("");
    const [detailList, setDetailList] = useState("no");
    const [FilePath, setFilePath] = useState(variables.FILE_URL);
    const [ImagePath, setImagePath] = useState(variables.IMAGE_URL);
    const [SchemaPath, setSchemaPath] = useState(variables.SCHEMA_URL);
    
    // currentLanguage artık i18n'den dinamik alınacak
    
    const [downloadingId, setDownloadingId] = useState(null);
    const [imgSchema, setImgSchema] = useState("");
    const [orjinalKodu, setOrjinalKodu] = useState("");
    const [imgProduct, setImgProduct] = useState("");
    const [filter, setFilter] = useState('');

    useEffect(() => {
        //refreshGroups();
       refreshList()
    }, []);

    const sorting = (columnName) => {
        let sortedList = [...products];
        if (sortOrder === "ASC") {
            sortedList.sort((a, b) => a[columnName] > b[columnName] ? 1 : -1);
            setSortOrder("DSC");
        } else {
            sortedList.sort((a, b) => a[columnName] < b[columnName] ? 1 : -1);
            setSortOrder("ASC");
        }
        setProducts(sortedList);
    };

    const refreshList = async () => {
        //setDetailList('yes');
        if (aranacakMetin != '') {
            try {
                const data = await productService.getProducts(aranacakMetin, model3bCheck);
                if (data.length == 0) { toast(t('mesajUrunBulunamadi')) } else { toast(data.length + t('mesajUrunBulundu')) }
                setProducts(data);
            } catch (error) {
                toast.warning(t('mesajOturumZamanAsimi'))
                const link = document.createElement('a');
                link.href = "/login";
                document.body.appendChild(link);
                link.click();
            }
        }
    };

    const refreshGroups = async () => {
        setDetailList('no');
        try {
            const data = await productService.getProductGroups(groupCode);
            if (data.length == 0) { toast(t('mesajUrunBulunamadi')) }
            setProductGroups(data);
        } catch (error) {
            toast.warning(t('mesajOturumZamanAsimi'))
            const link = document.createElement('a');
            link.href = "/login";
            document.body.appendChild(link);
            link.click();
        }
    };

    const downloadPdfFile = async (product) => {
        const downloadKey = `${product.Id}-pdf`;
        setDownloadingId(downloadKey);
        toast.info(t('mesajPdfIndirmeBasladi'));

        try {
            const data = await productService.downloadFile(product.PdfFile, sessionStorage.getItem("activationKey"), product.Id, 'pdf');
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            var dosyaAdi = product.PdfFile
            link.setAttribute('download', dosyaAdi);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error("PDF download failed", error);
            toast.error(t('mesajDosyaIndirmeHatasi') || "File download failed");
        } finally {
            setDownloadingId(null);
        }
    };

    const downloadStepFile = async (product) => {
        const downloadKey = `${product.Id}-step`;
        setDownloadingId(downloadKey);
        toast.info(t('mesajStepIndirmeBasladi'));

        try {
            const data = await productService.downloadFile(product.StepFile, sessionStorage.getItem("activationKey"), product.Id, 'step');
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            var dosyaAdi = product.StepFile
            link.setAttribute('download', dosyaAdi);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error("Step file download failed", error);
            toast.error(t('mesajDosyaIndirmeHatasi') || "File download failed");
        } finally {
            setDownloadingId(null);
        }
    };

    const changeAranacakMetin = (e) => {
        setAranacakMetin(e.target.value);
    };

    const changeModel3b = (e) => {
        setModel3bCheck(e.target.checked ? "1" : "0");
    };

    const changeGroupCode = (e) => {
        setGroupCode(e);
        if (e == "*" || e == "") { setAranacakMetin('*') };
        if (e.split("-").length == 2) {
            setAranacakMetin(e);
            refreshList();
            const rootCode = e.split("-")
            setRootGroupCode(rootCode[0]);
        } else {
            setRootGroupCode('');
            refreshGroups();
        }
    };

    const searchClick = () => {
        setRootGroupCode('');
        refreshList();
    };

    const showPopUpSchema = (urunObj) => {
        setImgSchema(variables.SCHEMA_URL + urunObj.SchemaFile);
        setOrjinalKodu(urunObj.OrjinalKodu);
    };

    const showPopUpImg = (urunObj) => {
        setImgProduct(variables.IMAGE_URL + urunObj.ImageFile);
        setOrjinalKodu(urunObj.OrjinalKodu);
    };

    const showPopUp3d = (pUrl) => {
        setProductUrl(pUrl);
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    const filteredProducts = products.filter(product => 
        product.KatalogKodu.toLowerCase().includes(filter.toLowerCase())
    );

    const thStyle = {
        fontSize: '11px',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: '#94a3b8',
        padding: '12px 16px',
        borderBottom: '2px solid #f1f5f9',
        whiteSpace: 'nowrap',
        background: '#f8fafc',
    };

    const actionBtn = (bg, color) => ({
        background: bg,
        border: 'none',
        borderRadius: '8px',
        padding: '6px 8px',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
        color,
    });

    const groupsByCategory = filteredProducts.reduce((acc, prd) => {
        const catName = i18n.language === 'tr' ? prd.Kategori : prd.Category;
        if (!acc[catName]) acc[catName] = [];
        acc[catName].push(prd);
        return acc;
    }, {});

    return (
        <div style={{ maxWidth: '1200px' }}>

            {/* ── Toolbar ── */}
            <div className="card border-0 shadow-sm rounded-4 mb-4" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                <div className="card-body p-3 d-flex align-items-center justify-content-end gap-3">
                    <QuickSearchInput
                        value={filter}
                        onChange={handleFilterChange}
                        onSearchSubmit={(val) => {
                            setFilter(val);
                        }}
                        placeholder={t('aranacakMetin')}
                        width="480px"
                    />
                </div>
            </div>

            {/* ── Kart Görünümü ── */}
            {detailList === 'no' && (
                <div>
                    {/* Kategori hızlı nav */}
                    {Object.keys(groupsByCategory).length > 1 && (
                        <div className="d-flex gap-2 mb-4 flex-wrap" style={{ position: 'sticky', top: 68, zIndex: 9, background: '#ebebeb', paddingTop: 8, paddingBottom: 8 }}>
                            {Object.keys(groupsByCategory).map(catName => (
                                <span
                                    key={catName}
                                    onClick={() => document.getElementById('cat3d-' + catName)?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                                    style={{
                                        background: '#f0fdf4', color: '#0e7c5a', cursor: 'pointer',
                                        fontWeight: 600, fontSize: '13px', padding: '5px 14px',
                                        borderRadius: '20px', userSelect: 'none',
                                    }}
                                >
                                    {catName}
                                </span>
                            ))}
                        </div>
                    )}

                    {/* Kategori bölümleri */}
                    {Object.keys(groupsByCategory).map(categoryName => (
                        <div key={categoryName} id={'cat3d-' + categoryName} className="mb-5" style={{ scrollMarginTop: '80px' }}>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div style={{
                                    fontSize: '11px', fontWeight: 700, textTransform: 'uppercase',
                                    letterSpacing: '1px', color: '#94a3b8',
                                    display: 'flex', alignItems: 'center', gap: '8px',
                                }}>
                                    <Icon3dCubeSphere size={14} />
                                    {categoryName}
                                </div>
                                <span
                                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                    style={{ cursor: 'pointer', color: '#94a3b8', fontSize: '12px' }}
                                >
                                    ↑ {t('anaUrunGruplari')}
                                </span>
                            </div>
                            <div style={{ height: '1px', background: '#e2e8f0', marginBottom: '20px' }} />

                            <div className="row g-3">
                                {groupsByCategory[categoryName].map(prd => (
                                    <div className="col-6 col-sm-4 col-md-3 col-xl-2" key={prd.ID || prd.OrjinalKodu}>
                                        <div
                                            className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden"
                                            style={{ cursor: 'pointer', transition: 'transform 0.15s, box-shadow 0.15s', position: 'relative' }}
                                            data-bs-toggle="modal"
                                            data-bs-target="#3dPopUp"
                                            onClick={() => showPopUp3d(prd.ModelFile)}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.transform = 'translateY(-4px)';
                                                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '';
                                            }}
                                        >
                                            {/* 3D badge */}
                                            <div style={{
                                                position: 'absolute', top: 8, right: 8,
                                                background: '#0e7c5a', color: '#fff',
                                                borderRadius: '20px', fontSize: '10px',
                                                fontWeight: 700, padding: '3px 8px',
                                                lineHeight: 1, display: 'flex', alignItems: 'center', gap: '3px',
                                            }}>
                                                <Icon3dCubeSphere size={10} />
                                                3D
                                            </div>

                                            {/* Görsel */}
                                            <div style={{
                                                height: 130, display: 'flex', alignItems: 'center',
                                                justifyContent: 'center', padding: '16px', background: '#fafafa',
                                            }}>
                                                <img
                                                    src={ImagePath + prd.ImageFile}
                                                    alt={prd.OrjinalKodu}
                                                    style={{ maxHeight: '100px', maxWidth: '100%', objectFit: 'contain' }}
                                                />
                                            </div>

                                            {/* Ürün kodu */}
                                            <div style={{
                                                padding: '10px', borderTop: '1px solid #f1f5f9',
                                                textAlign: 'center',
                                            }}>
                                                <span style={{ fontWeight: 700, fontSize: '15px', color: '#1e293b' }}>
                                                    {prd.OrjinalKodu}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* ── Tablo Görünümü ── */}
            {detailList === 'yes' && (
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                    <table className="table table-hover mb-0 align-middle">
                        <thead>
                            <tr>
                                <th style={thStyle}>{t('tabloBaslikResim')}</th>
                                <th style={{ ...thStyle, cursor: 'pointer' }} onClick={() => sorting("OrjinalKodu")}>
                                    {t('tabloBaslikUrunKodu')} ↕
                                </th>
                                <th style={{ ...thStyle, cursor: 'pointer' }} onClick={() => sorting("KatalogKodu")}>
                                    {t('tabloBaslikAciklama')} ↕
                                </th>
                                <th style={{ ...thStyle, textAlign: 'center' }}>{t('tabloBaslikPdfOnizleme')}</th>
                                <th style={{ ...thStyle, textAlign: 'center' }}>{t('tabloBaslikPdfDosya')}</th>
                                <th style={{ ...thStyle, textAlign: 'center' }}>{t('tabloBaslikStepDosya')}</th>
                                <th style={{ ...thStyle, textAlign: 'center' }}>{t('tabloBaslikModelDosya')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredProducts.map(prd => (
                                <tr key={prd.Id}>
                                    <td style={{ padding: '10px 16px' }}>
                                        <img
                                            src={ImagePath + prd.ImageFile}
                                            width="50"
                                            alt=""
                                            style={{ borderRadius: '8px', cursor: 'pointer', objectFit: 'contain' }}
                                            data-bs-toggle="modal"
                                            data-bs-target="#imgPopUp"
                                            onClick={() => showPopUpImg(prd)}
                                        />
                                    </td>
                                     <td style={{ padding: '12px 16px', minWidth: '180px' }}>
                                         <div className="d-flex flex-column gap-1">
                                             <span style={{ fontWeight: 700, color: '#0f172a', fontSize: '14px' }}>
                                                 {prd.OrjinalKodu}
                                             </span>
                                             <span style={{ color: '#64748b', fontSize: '12px', fontWeight: 500 }}>
                                                 {formatKatalogKodu(prd.KatalogKodu)}
                                             </span>
                                         </div>
                                     </td>
                                     <td style={{ padding: '12px 16px', color: '#334155', fontSize: '13px', lineHeight: '1.45', whiteSpace: 'normal', wordBreak: 'break-word', minWidth: '280px' }}>
                                         {prd.ParsedDetails?.TamAciklama || formatKatalogKodu(prd.KatalogKodu)}
                                     </td>
                                    <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                                        {prd.SchemaFile && (
                                            <button style={actionBtn('#fff7ed', '#ea580c')} data-bs-toggle="modal" data-bs-target="#schemaPopUp" onClick={() => showPopUpSchema(prd)}>
                                                <img width={32} src={schemaIcon} alt="Schema" />
                                            </button>
                                        )}
                                    </td>
                                    <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                                        {prd.PdfFile && (
                                            <button style={actionBtn('#fef2f2', '#dc2626')} onClick={() => downloadPdfFile(prd)} disabled={downloadingId !== null}>
                                                {downloadingId === `${prd.Id}-pdf` ? (
                                                    <div className="spinner-border spinner-border-sm text-danger" role="status" style={{ width: 20, height: 20 }} />
                                                ) : (
                                                    <img width={32} src={pdfIcon} alt="PDF" style={{ opacity: downloadingId !== null && downloadingId !== `${prd.Id}-pdf` ? 0.4 : 1 }} />
                                                )}
                                            </button>
                                        )}
                                    </td>
                                    <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                                        {prd.StepFile && (
                                            <button style={actionBtn('#eff6ff', '#2563a8')} onClick={() => downloadStepFile(prd)} disabled={downloadingId !== null}>
                                                {downloadingId === `${prd.Id}-step` ? (
                                                    <div className="spinner-border spinner-border-sm text-primary" role="status" style={{ width: 20, height: 20 }} />
                                                ) : (
                                                    <img width={32} src={stepIcon} alt="STEP" style={{ opacity: downloadingId !== null && downloadingId !== `${prd.Id}-step` ? 0.4 : 1 }} />
                                                )}
                                            </button>
                                        )}
                                    </td>
                                    <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                                        {prd.ModelFile && (
                                            <button style={actionBtn('#f0fdf4', '#16a34a')} data-bs-toggle="modal" data-bs-target="#3dPopUp" onClick={() => showPopUp3d(prd.ModelFile)}>
                                                <img width={32} src={ucdIcon} alt="3D" />
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ── Modaller ── */}
            <div className="modal fade" id="schemaPopUp" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t('tabloBaslikPdfOnizleme')} {orjinalKodu}</h4>
                        </div>
                        <div className="modal-body text-center">
                            <img width={650} src={imgSchema} alt="Schema Preview" />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">{t('butonKapat')}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="imgPopUp" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t('tabloBaslikResim')} {orjinalKodu}</h4>
                        </div>
                        <div className="modal-body">
                            <img className="mx-auto d-block img-fluid" src={imgProduct} alt="Product" />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">{t('butonKapat')}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="3dPopUp" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog custom-modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{t('menu3dView')}</h4>
                            <button type="button" className="btn" data-bs-dismiss="modal">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708" />
                                </svg>
                            </button>
                        </div>
                        <div className="modal-body">
                            <IFrameWindow productUrl={productUrl} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThreeDProducts;